import { createPortal } from "react-dom";
import { Button, Modal } from "shared";
import { useDeleteInvestment } from "hooks/investments";
import { InvestmentItem } from "../../types";

interface DeleteInvestmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: InvestmentItem | null;
}

const DeleteInvestmentModal = ({
  isOpen,
  onClose,
  item,
}: DeleteInvestmentModalProps) => {
  const { mutate: deleteInvestment, isPending } = useDeleteInvestment();

  const handleDelete = () => {
    if (!item) return;
    deleteInvestment(
      { uuid: item.uuid },
      {
        onSuccess: () => {
          onClose();
        },
      },
    );
  };

  return createPortal(
    <Modal isOpened={isOpen} onClose={onClose}>
      <>
        <div className="modal-heading">Usuwanie aktywa</div>
        <div className="modal-description">
          Czy jesteś pewien, że chcesz usunąć aktywo{" "}
          {item?.name ? <span>{item.name}</span> : ""} wraz z historią
          transakcji?
        </div>
        <div className="modal-buttons">
          <Button
            className="button--stroke button--rounded"
            onClick={onClose}
            label="Anuluj"
          />
          <Button
            className="button--black button--rounded"
            onClick={handleDelete}
            label={isPending ? "Usuwanie..." : "Potwierdź"}
          />
        </div>
      </>
    </Modal>,
    document.body,
  );
};

export default DeleteInvestmentModal;
